export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL!;

export const fetchActiveHeroes = async () => {
  const response = await fetch(`${API_BASE_URL}/heroes/active`);
  if (!response.ok) {
    throw new Error('Failed to fetch active heroes');
  }
  return response.json();
};

export const fetchTestimonials = async () => {
  const response = await fetch(`${API_BASE_URL}/testimonials`);
  if (!response.ok) {
    throw new Error('Failed to fetch testimonials');
  }
  return response.json();
};

export const fetchLitigations = async () => {
  const response = await fetch(`${API_BASE_URL}/litigations`);
  if (!response.ok) {
    throw new Error('Failed to fetch litigations');
  }
  return response.json();
};

export const fetchInsights = async () => {
  const response = await fetch(`${API_BASE_URL}/insights`);
  if (!response.ok) {
    throw new Error('Failed to fetch insights');
  }
  return response.json();
};

export const fetchBlogs = async () => {
  const response = await fetch(`${API_BASE_URL}/blogs`);
  if (!response.ok) {
    throw new Error('Failed to fetch blogs');
  }
  return response.json();
};

export const postContact = async (data: {
  name: string;
  email: string;
  phone: string;
  message: string;
}) => {
  const response = await fetch(`${API_BASE_URL}/contact`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.error || 'Failed to submit contact form');
  }

  return result;
};

export const fetchAboutHome = async () => {
  const response = await fetch(`${API_BASE_URL}/abouthome`);
  if (!response.ok) {
    throw new Error('Failed to fetch about home data');
  }
  return response.json();
};

export const fetchAboutMain = async () => {
  const response = await fetch(`${API_BASE_URL}/aboutmain`);
  if (!response.ok) {
    throw new Error('Failed to fetch about main data');
  }
  return response.json();
};

export const fetchServices = async () => {
  const response = await fetch(`${API_BASE_URL}/service`);
  if (!response.ok) {
    throw new Error('Failed to fetch service data');
  }
  return response.json();
};

export const fetchServicePackages = async () => {
  const response = await fetch(`${API_BASE_URL}/package`);
  if (!response.ok) {
    throw new Error('Failed to fetch service packages');
  }
  return response.json();
};

// lib/metadata.ts
export const fetchMetadata = async (page: string) => {
  const response = await fetch(`${API_BASE_URL}/metadata/${page}`);
  if (!response.ok) {
    throw new Error('Failed to fetch metadata');
  }
  return response.json();
};

export const subscribeToNews = async (email: string): Promise<any> => {
  const response = await fetch(`${API_BASE_URL}/news`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ address: email }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Failed to subscribe');
  }

  return data;
};
